import { useEffect } from 'react';
import { useSharedStore } from '../stores/sharedStore';
import { Header } from '../components/ui/Header';

export function Library() {
  const { books, booksLoading, booksError, loadBooks } = useSharedStore();

  useEffect(() => { loadBooks(); }, [loadBooks]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-6xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold mb-6">📖 绘本图书馆</h2>
        {booksLoading && <div className="text-center py-12 text-gray-500">加载中...</div>}
        {booksError && <div className="bg-red-50 text-red-600 p-4 rounded-lg">{booksError}</div>}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {books.map((book) => (
            <div key={book.id} className="bg-white rounded-xl shadow-sm hover:shadow-lg transition overflow-hidden cursor-pointer"
              onClick={() => window.location.href = `/?mode=reader&book=${book.slug}`}>
              <div className="aspect-[3/4] bg-gradient-to-br from-blue-100 to-purple-100 flex items-center justify-center">
                {book.cover_image ? (
                  <img src={book.cover_image} alt={book.title} className="w-full h-full object-cover" />
                ) : (
                  <span className="text-4xl">📚</span>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg mb-1">{book.title}</h3>
                <p className="text-sm text-gray-500 mb-2">{book.author || 'AI Studio'}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs bg-gray-100 px-2 py-1 rounded-full">{book.category || '童话'}</span>
                  {book.is_free ? (
                    <span className="text-xs text-green-600 font-medium">免费</span>
                  ) : (
                    <span className="text-xs text-blue-600 font-medium">¥{(book.price_cents / 100).toFixed(0)}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
